import Vue from "vue";
import "./plugins/axios";

import VueCryptojs from "vue-cryptojs";
import App from "./App.vue";
import App2 from "./App2.vue";
import router from "./router";
import store from "./store";
import VModal from "vue-js-modal";
import IdleVue from "idle-vue";
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

import common from "./plugins/common";

//import constants from "./api/constants";
import utilPlugin from "./plugins/util";
import constPlugin from "./plugins/constants";
import keyPadPlugin from "./plugins/keypad";

Vue.config.productionTip = false;

Vue.use(VModal, {
  dialog: true
});

Vue.use(VueSidebarMenu);

Vue.use(VueCryptojs); //암호화 라이브러리

Vue.use(common); //전역 일반 함수 등록
Vue.use(utilPlugin); //전역 Util Function
Vue.use(constPlugin); //전역 상수 등록
Vue.use(keyPadPlugin); //키패드 플러그인

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1000 * 60 * 20,
  startAtIdle: false
});

new Vue({
  router,
  store,
  // render: h => h(App)
  render: function (h) {
    // 서류제출 컴포넌트 분리하기 위해..
    if(window.location.pathname == '/VARS20001' ||
        window.location.pathname == '/VARS20002' ||
        window.location.pathname == '/VARS20003' ||
        window.location.pathname == '/VARS20011' ||
        window.location.pathname == '/VARS20012'){
      return h(App2);
    } else {
      return h(App);
    }
  },
}).$mount("#app");